var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEwallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5C1.45 18.5 0.979167 18.3042 0.5875 17.9125C0.195833 17.5208 0 17.05 0 16.5V2.5C0 1.95 0.195833 1.47917 0.5875 1.0875C0.979167 0.695833 1.45 0.5 2 0.5H16C16.55 0.5 17.0208 0.695833 17.4125 1.0875C17.8042 1.47917 18 1.95 18 2.5V5H16V2.5H2V16.5H16V14H18V16.5C18 17.05 17.8042 17.5208 17.4125 17.9125C17.0208 18.3042 16.55 18.5 16 18.5H2ZM10 14.5C9.45 14.5 8.97917 14.3042 8.5875 13.9125C8.19583 13.5208 8 13.05 8 12.5V6.5C8 5.95 8.19583 5.47917 8.5875 5.0875C8.97917 4.69583 9.45 4.5 10 4.5H17C17.55 4.5 18.0208 4.69583 18.4125 5.0875C18.8042 5.47917 19 5.95 19 6.5V12.5C19 13.05 18.8042 13.5208 18.4125 13.9125C18.0208 14.3042 17.55 14.5 17 14.5H10ZM17 12.5V6.5H10V12.5H17ZM13 11C13.4167 11 13.7708 10.8542 14.0625 10.5625C14.3542 10.2708 14.5 9.91667 14.5 9.5C14.5 9.08333 14.3542 8.72917 14.0625 8.4375C13.7708 8.14583 13.4167 8 13 8C12.5833 8 12.2292 8.14583 11.9375 8.4375C11.6458 8.72917 11.5 9.08333 11.5 9.5C11.5 9.91667 11.6458 10.2708 11.9375 10.5625C12.2292 10.8542 12.5833 11 13 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwallet);
export default __webpack_public_path__ + "static/media/ewallet.a4f01802dac9fb3db71f0d4c35543800.svg";
export { ForwardRef as ReactComponent };